import { render } from "./Complex.vue?vue&type=template&id=128c3e18"
import script from "./Complex.vue?vue&type=script&lang=js"
export * from "./Complex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__